import { ArrowIcon } from "./ArrowIcon";
import { AudienceIcon } from "./AudienceIcon";
import { BoxIcon } from "./BoxIcon";
import { BulbIcon } from "./BulbIcon";
import { CalendarIcon } from "./CalendarIcon";
import { ChatPersonIcon } from "./ChatPersonIcon";
import { CheckCircleIcon } from "./CheckCircleIcon";
import { CheckIcon } from "./CheckIcon";
import { ClipboardIcon } from "./ClipboardIcon";
import { ClockIcon } from "./ClockIcon";
import { CloseIcon } from "./CloseIcon";
import { CompanyIcon } from "./CompanyIcon";
import { CopyIcon } from "./CopyIcon";
import { DownloadIcon } from "./DownloadIcon";
import { EditIcon } from "./EditIcon";
import { EmployeeIcon } from "./EmployeeIcon";
import { FlagIcon } from "./FlagIcon";
import { GlobeIcon } from "./GlobeIcon";
import { GoogleG } from "./GoogleG";
import { GraduationHatIcon } from "./GraduationHatIcon";
import { HamburgerIcon } from "./HamburgerIcon";
import { HelpIcon } from "./HelpIcon";
import { InfoIcon } from "./InfoIcon";
import { LockIcon } from "./LockIcon";
import { MailIcon } from "./MailIcon";
import { ManagementIcon } from "./ManagementIcon";
import { ManyPeopleIcon } from "./ManyPeopleIcon";
import { MessageIcon } from "./MessageIcon";
import { Microsoft } from "./Microsoft";
import { MinusIcon } from "./MinusIcon";
import { NavArrow } from "./NavArrow";
import { Okta } from "./Okta";
import { PersonStandingIcon } from "./PersonStanding";
import { PlusIcon } from "./PlusIcon";
import { PreviewIcon } from "./PreviewIcon";
import { RedArrowIcon } from "./RedArrowIcon";
import { RestoreIcon } from "./RestoreIcon";
import { ShareIcon } from "./ShareIcon";
import { ShuttleIcon } from "./ShuttleIcon";
import { ThumbIcon } from "./ThumbIcon";
import { TouchpointIcon } from "./TouchpointIcon";
import { TrashIcon } from "./TrashIcon";
import { TrophyIcon } from "./TrophyIcon";
import { UploadIcon } from "./UploadIcon";
import { UserIcon } from "./UserIcon";
import { WarningIcon } from "./WarningIcon";

export enum IconTypes {
  "Arrow" = "Arrow",
  "Audience" = "Audience",
  "Box" = "Box",
  "Bulb" = "Bulb",
  "Calendar" = "Calendar",
  "ChatPerson" = "ChatPerson",
  "Check" = "Check",
  "CheckCircle" = "CheckCircle",
  "Clipboard" = "Clipboard",
  "Clock" = "Clock",
  "Close" = "Close",
  "Company" = "Company",
  "Copy" = "Copy",
  "Download" = "Download",
  "Edit" = "Edit",
  "Employee" = "Employee",
  "Flag" = "Flag",
  "Globe" = "Globe",
  "GraduationHat" = "GraduationHat",
  "GoogleG" = "GoogleG",
  "Hamburger" = "Hamburger",
  "Help" = "Help",
  "Info" = "Info",
  "Lock" = "Lock",
  "Mail" = "Mail",
  "Management" = "Management",
  "ManyPeople" = "ManyPeople",
  "Message" = "Message",
  "Microsoft" = "Microsoft",
  "Minus" = "Minus",
  "NavArrow" = "NavArrow",
  "Okta" = "Okta",
  "PersonStanding" = "PersonStanding",
  "Plus" = "Plus",
  "Preview" = "Preview",
  "RedArrow" = "RedArrow",
  "Restore" = "Restore",
  "Share" = "Share",
  "Shuttle" = "Shuttle",
  "Thumb" = "Thumb",
  "Touchpoint" = "Touchpoint",
  "Trash" = "Trash",
  "Trophy" = "Trophy",
  "Upload" = "Upload",
  "User" = "User",
  "Warning" = "Warning",
}

export enum Direction {
  "LEFT" = "LEFT",
  "RIGHT" = "RIGHT",
  "UP" = "UP",
  "DOWN" = "DOWN",
}

export interface IconProps {
  direction?: Direction;
  onClick?: (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => void;
  className?: string;
  size?: number; // size in px
  small?: boolean;
  width?: number;
  height?: number;
  color?: string; // Can be a hex value, secondary or white
  onMouseEnter?: (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => void;
  isChecked?: boolean;
  variant?: "filled" | "outlined";
}

type IAllIcons = {
  [key in IconTypes]: (props: IconProps) => JSX.Element;
};

const allIcons: IAllIcons = {
  [IconTypes.Arrow]: ArrowIcon,
  [IconTypes.Audience]: AudienceIcon,
  [IconTypes.Box]: BoxIcon,
  [IconTypes.Bulb]: BulbIcon,
  [IconTypes.Calendar]: CalendarIcon,
  [IconTypes.ChatPerson]: ChatPersonIcon,
  [IconTypes.Check]: CheckIcon,
  [IconTypes.CheckCircle]: CheckCircleIcon,
  [IconTypes.Clipboard]: ClipboardIcon,
  [IconTypes.Clock]: ClockIcon,
  [IconTypes.Close]: CloseIcon,
  [IconTypes.Company]: CompanyIcon,
  [IconTypes.Copy]: CopyIcon,
  [IconTypes.Download]: DownloadIcon,
  [IconTypes.Edit]: EditIcon,
  [IconTypes.Employee]: EmployeeIcon,
  [IconTypes.Flag]: FlagIcon,
  [IconTypes.Globe]: GlobeIcon,
  [IconTypes.GraduationHat]: GraduationHatIcon,
  [IconTypes.GoogleG]: GoogleG,
  [IconTypes.Hamburger]: HamburgerIcon,
  [IconTypes.Help]: HelpIcon,
  [IconTypes.Info]: InfoIcon,
  [IconTypes.Lock]: LockIcon,
  [IconTypes.Mail]: MailIcon,
  [IconTypes.Management]: ManagementIcon,
  [IconTypes.ManyPeople]: ManyPeopleIcon,
  [IconTypes.Message]: MessageIcon,
  [IconTypes.Microsoft]: Microsoft,
  [IconTypes.Minus]: MinusIcon,
  [IconTypes.NavArrow]: NavArrow,
  [IconTypes.Okta]: Okta,
  [IconTypes.PersonStanding]: PersonStandingIcon,
  [IconTypes.Plus]: PlusIcon,
  [IconTypes.Preview]: PreviewIcon,
  [IconTypes.RedArrow]: RedArrowIcon,
  [IconTypes.Restore]: RestoreIcon,
  [IconTypes.Share]: ShareIcon,
  [IconTypes.Shuttle]: ShuttleIcon,
  [IconTypes.Thumb]: ThumbIcon,
  [IconTypes.Touchpoint]: TouchpointIcon,
  [IconTypes.Trash]: TrashIcon,
  [IconTypes.Trophy]: TrophyIcon,
  [IconTypes.Upload]: UploadIcon,
  [IconTypes.User]: UserIcon,
  [IconTypes.Warning]: WarningIcon,
};

export default allIcons;
